import { axiosInstance } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import type {User} from "@/types/User";

const getUser = async ():Promise<User> => {
  const { data } = await axiosInstance.get<User>(
    `/api/auth/user/me?appId=lead`
  );
  return data;
};

export const useGetUser = () => {
  return useQuery({
    queryKey: ["user"],
    queryFn: getUser,
  });
};
